import React, { useContext } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { DropdownButton } from 'react-bootstrap';
import { CartContext } from '../cartContext';
import { Image } from 'react-bootstrap';
import defaultImage from '../../images/Logo.png';

export function CustomDropdown() {
  const { cartItems } = useContext(CartContext);

  const totalQuantity = cartItems.reduce((accumulator, item) => {
    return accumulator + item.quantity;
  }, 0);

  return (
    <>
      <div className="mb-2">
        <DropdownButton
          id={`dropdown-button-drop-start}`}
          drop="start"
          variant="danger"
          title={totalQuantity}
        >
          <div className={`col-12 text-center pt-2 text-white`} style={{ width: '300px', margin: '0 auto' }}>I din handlekurv:</div>
          {cartItems.map((item) => {
            const product = item.data || item;  // Håndter både Strapi standard og GraphQL struktur
            const productName = product.attributes?.name || 'Ukjent navn';
            const productImage = product.attributes?.image?.data?.attributes?.formats?.thumbnail?.url || defaultImage;

            return (
              <div className="cart-mini-card text-white text-center" key={item.combinedId}>
                <div className="col-10 m-auto">
                  <Image
                    className='cart-card-image-top'
                    fluid
                    src={productImage}
                    alt={productName}
                  />
                </div>
                <p>{productName}</p>
                <p>Antall: {item.quantity}</p>
              </div>
            );
          })}
          <Dropdown.Item className="text-center checkout-knapp text-white mt-3" href="/checkout">Checkout</Dropdown.Item>
        </DropdownButton>
      </div>
    </>
  );
}

export default CustomDropdown;


// import React, { useContext } from 'react';
// import Dropdown from 'react-bootstrap/Dropdown';
// import { DropdownButton } from 'react-bootstrap';
// import { CartContext } from '../cartContext';
// import { Image } from 'react-bootstrap';
// import defaultImage from '../../images/Logo.png';

// export function CustomDropdown() {
//   const { cartItems } = useContext(CartContext);

//   const totalQuantity = cartItems.reduce((accumulator, item) => {
//       return accumulator + item.quantity;
//   }, 0);

//   return (
//       <>
//           <div className="mb-2">
//               <DropdownButton
//                   id={`dropdown-button-drop-start}`}
//                   drop="start"
//                   variant="danger"
//                   title={totalQuantity}
//               >
//                   <div className="text-center pt-2 text-white">I din handlekurv:</div>
//                   {cartItems.map((item) => {
//                       const product = item.data || item;  // Håndter både Strapi standard og GraphQL struktur
//                       const productId = product.id || product.data?.id;  // Sjekk begge mulige ID-feltene
//                       const productName = product.attributes?.name || 'Ukjent navn';
//                       const productImage = product.attributes?.image?.data?.attributes?.formats?.thumbnail?.url || defaultImage;

//                       return (
//                           <div className="cart-mini-card text-white text-center" key={productId}>
//                               <div className="col-10 m-auto">
//                                   <Image
//                                       className='cart-card-image-top'
//                                       fluid
//                                       src={productImage}
//                                       alt={productName}
//                                   />
//                               </div>
//                               <p>{productName}</p>
//                               <p>Antall: {item.quantity}</p>
//                           </div>
//                       );
//                   })}
//                   <Dropdown.Item className="text-center checkout-knapp text-white mt-3" href="/checkout">Checkout</Dropdown.Item>
//               </DropdownButton>
//           </div>
//       </>
//   );
// }

// export default CustomDropdown;

// export function CustomDropdown() {
//     const { cartItems } = useContext(CartContext);

//     const totalQuantity= cartItems.reduce((accumulator, item) => {
//         return accumulator + item.quantity;
//     }, 0);

//   return (
    
//     <>
//         <div className="mb-2">
//             <DropdownButton
//               id={`dropdown-button-drop-start}`}
//               drop="start"
//               variant="danger"
//               title={totalQuantity}
//             >
//             <div className="text-center pt-2 text-white">I din handlekurv:</div>
//             {cartItems.map((item) => (
//                 <div className="cart-mini-card text-white text-center" key={item.data.id}>
//                     <div className="col-10 m-auto">
//                         <Image className='cart-card-image-top' fluid 
//                           src={item.data?.attributes?.image?.data?.attributes?.formats?.thumbnail?.url || defaultImage} 
//                           alt={item.data?.attributes?.name}/>
//                     </div>
//                     <p>{item.data.attributes.name}</p>
//                     <p>Antall: {item.quantity}</p>
//                 </div>
//             ))}
//               <Dropdown.Item className="text-center checkout-knapp text-white mt-3" href="/checkout">Checkout</Dropdown.Item>
//             </DropdownButton>
//         </div>
//     </>
//   );
// }

// export default CustomDropdown;





// <Dropdown>
    //   <Dropdown.Toggle variant="success" id="dropdown-basic">
    //     {totalQuantity}
    //   </Dropdown.Toggle>
    //   <Dropdown.Menu>
        
    //     <Dropdown.Item href="#/action-3">Checkout</Dropdown.Item>
    //   </Dropdown.Menu>
    // </Dropdown>